import { render, staticRenderFns } from "./PortalAdminContent2.vue?vue&type=template&id=5f284606&scoped=true&"
import script from "./portalAdminContent2.ts?vue&type=script&lang=ts&"
export * from "./portalAdminContent2.ts?vue&type=script&lang=ts&"
import style0 from "./PortalAdminContent2.vue?vue&type=style&index=0&id=5f284606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f284606",
  null
  
)

export default component.exports